// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import cn from 'classnames';
import {Link, useHistory} from 'react-router-dom';
import {Settings_context} from '../../settings_ctx';
import {statuses} from '../../data_ctx';
import etask from 'zetask';
// @ts-ignore
import {use_data_provider} from '../../lib/use_data_provider';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {get_article_date, i_arts} from '../../ui/blog/i_blog';
import {use_pathname} from '../../lib/use_pathname';
import {perr_www_visit} from 'hola_pub_util';
import {use_fetch_posts} from '../../ui/blog/use_fetch_posts';
import {img_url} from '../../ui/img_url';
import {Spacer} from '../../ui/homepage/spacer';
import {Article_card} from '../../ui/blog/article_card';
import {use_scrollbox} from '../../ui/use_scrollbox';
import {Paging} from '../../ui/blog/paging';
import {Loader} from '../../ui/media/loader';
import {use_screen} from '../../lib/screen_util';
import {use_qs_with_set} from '../../lib/use_qs';
import {www_hola} from 'hola_opt';
import {Svg_img} from '../../ui/svg_img';

import styles from './blog/blog_main.module.less';

const root_path = '/blog';

const get_data_id = params=>`/blog/page/${params.page}/category/`+
    `${params.category}/per_page/${params.per_page||9}`;

const First_article = props=>{
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const category = props.category||'all';
    return <div className={cn(theme.container, styles.latest_news_container)}>
      <div className={styles.latest_news} onClick={()=>{
        history.push(`/blog/${category}/${props.slug}`);
      }} key={props.id}>
        <div className={cn(styles.latest_news_img, 'lazyload')}
          data-bg={props.preview_image || props.img || undefined}
          style={props.preview_bg ? {backgroundColor: props.preview_bg} : {}}>
        </div>
        <div className={styles.latest_news_content}>
          <div className={cn(styles.news_date, theme.u3, theme.reg)}>
            {get_article_date(props)}</div>
          <div className={styles.latest_news_text}>
            <h5 className={theme.reg}
              dangerouslySetInnerHTML={{__html: props.title}}></h5>
            <p className={cn(theme.p2, styles.read_more)}>
              <Link to={`/blog/${category}/${props.slug}`}
                key={props.slug} className={cn(theme.reg, theme.primary)}
                aria-label={`Open article: ${props.title}`}>Read more</Link>
            </p>
          </div>
        </div>
      </div>
    </div>;
};

export const Root = props=>{
    const {theme} = useContext(Settings_context);
    const root_url = root_path;
    const {data} = use_data_provider(get_data_id);
    const {params} = use_pathname();
    const {qs} = use_qs_with_set();
    const [data_state, set_data_state] = useState(data.result as i_arts);
    const root_ref = useRef<HTMLDivElement>();
    const categories_ref = useRef<HTMLDivElement>();
    const posts_url = `https://hola.org/cms_api/blog/posts`;
    const {width} = use_screen();
    const scroll_to_top = ()=>{
        const top = root_ref.current.offsetTop - 100;
        window.scroll({left: 0, top, behavior: 'smooth'});
    };
    const on_load_more = page=>{
        set_data_state(st=>({data: {
            ...st.data,
            posts: page.posts,
        }}));
    };
    const {is_loading, abort} = use_fetch_posts({container: root_ref.current,
        posts_url, on_load_more, category: params.category,
        paged: params.page, per_page: {all: 6, xl: 9, xs: 5}});
    useEffect(()=>{
        if (data.status==statuses.done)
        {
            abort();
            set_data_state(data.result as i_arts);
        }
    }, [data]);
    useEffect(()=>{ perr_www_visit({id: 'www_blog_visit'}); }, []);
    const arrows_scroll = qs.debug_ui || www_hola.blog_arrows_scroll;
    const {is_dragging, scroll_pos, scroll} = use_scrollbox(categories_ref,
        !arrows_scroll);
    const fa = data_state?.data?.posts[0];
    const show_fa = fa && (!params.page || params.page =='1');
    const root_cls = cn(theme.root, styles.root, {
        [styles.with_arrows]: arrows_scroll,
    });
    const Header_tag = !params.page ? 'h1': 'h3';
    return <div className={root_cls}>
      <Header_tag className={styles.title}>
        {props.title || 'Stay up-to-date with all the latest news'}
      </Header_tag>
      {show_fa &&
        <div className={styles.first_article_container}>
            <First_article {...fa} category={params?.category}/>
        </div>
      }
      {data_state && data_state.data && <div
        className={styles.categories_container}>
        <div className={cn(theme.container, styles.categories)}>
          <h5 className={cn(theme.primary, styles.categories_title)}>
            Browse by category</h5>
          <div className={styles.categories_box}>
            <div className={styles.scroll_btns}>
              <button
                className={cn(styles.prev, scroll_pos<=0.05 && styles.hidden)}
                style={{pointerEvents: scroll_pos<=0.05 ? 'none' : undefined}}
                onClick={()=>{
                  scroll(width >= 768 ? 50 : 20, 'bw', '%');
                }}>
                <Svg_img w={24} h={24}
                  id={'hola2023/icons/24/chevron_left.svg'}/>
              </button>
              <button
                className={cn(styles.next, scroll_pos>=0.95 && styles.hidden)}
                style={{pointerEvents: scroll_pos>=0.95 ? 'none' : undefined}}
                onClick={()=>{
                  scroll(width >= 768 ? 50 : 20, 'fw', '%');
                }}>
                <Svg_img w={24} h={24}
                  id={'hola2023/icons/24/chevron_right.svg'}/>
              </button>
            </div>
            <div ref={categories_ref} className={styles.categories_wrapper}
              style={{cursor: is_dragging ? 'grabbing' : undefined}}>
              <div className={styles.categories_buttons} style={{
                pointerEvents: is_dragging ? 'none' : undefined,
              }}>
                <Link className={cn(styles.category_button, theme.p3,
                  !params.category && styles.category_button__active)}
                  to={`${root_url}`}>
                  <img src={img_url('blog/globe.svg')} alt={'Open all'}
                    width="24px" height="24px" className="lazyload"/>All
                </Link>
                {data_state.data.categories.map(cat=>{
                    const cat_cls = cn(styles.category_button, theme.p3,
                        cat.slug==params.category ?
                        styles.category_button__active : '');
                    const cat_img = cat.img ? <img src={cat.img}
                      alt={cat.name} width="24px" height="24px"
                      className="lazyload"/> : null;
                    return <Link key={cat.id} className={cat_cls}
                      to={`${root_url}/${cat.slug}`}>
                      {cat_img}{cat.name}
                    </Link>;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>}
      <div className={cn(theme.container, styles.container)}>
        {data_state && data_state.data ? <Fragment>
          <div className={styles.articles} ref={root_ref}
            key={params.category}>
            {data_state.data.posts.map(v=><Article_card key={v.id}
              category={params.category||'general'} {...v}/>)}
          </div>
        </Fragment> : <div>Loading...</div>}
        <Paging count={data_state?.data?.total_pages} param="page"
          category={params.category} short={width<640}
          on_change={scroll_to_top}/>
        <Loader is_loading={is_loading} cls={styles.loader}/>
        <Spacer/>
        <Spacer/>
      </div>
    </div>;
};
Root.meta = {
    ssr_force: true,
    nosearch: true,
    default_theme: 'hola2023',
    meta: ({data_from_provider})=>{
        const category = data_from_provider && data_from_provider[0]?.category;
        switch (category)
        {
        case 'blog-blog':
            return {
                title: 'Hola | Explore Our Insights: The Latest Hola News '
                    +'and Trends',
                description: 'Join us in revolutionizing content access '
                    +'worldwide! Look no further than our blog for the latest '
                    +'news, expert insights, helpful how-to guides, and so '
                    +'much more!',
                canonical_url: 'https://hola.org/blog/blog-blog',
            };
        case 'general':
            return {
                title: 'Hola | Explore Our Insights: The Latest Hola News '
                    +'and Trends',
                description: 'Join us in revolutionizing content access '
                    +'worldwide! Look no further than our blog for the latest '
                    +'news, expert insights, helpful how-to guides, and so '
                    +'much more!',
                canonical_url: 'https://hola.org/blog/general',
            };
        case 'gaming':
            return {
                title: 'Hola | Explore Our Insights: The Latest Hola News '
                    +'and Trends',
                description: 'Join us in revolutionizing content access '
                    +'worldwide! Look no further than our blog for the latest '
                    +'news, expert insights, helpful how-to guides, and so '
                    +'much more!',
                canonical_url: 'https://hola.org/blog/gaming',
            };
        case 'how_to':
            return {
                title: 'Hola | Learn What You Need To Know With Our How To '
                    +'Guides',
                description: 'Confused about our service? Our "How To" '
                    +'category offers a comprehensive collection of guides '
                    +'to help you learn all you need to know about using '
                    +'Hola.',
                canonical_url: 'https://hola.org/blog/how_to',
            };
        case 'in-depth':
            return {
                title: 'Hola Blog | Our In-Depth and Insightful Articles',
                description: 'Our "In-Depth" category provides insightful '
                    +'articles on our service, app, and using Hola. Dive '
                    +'deep & explore our collection of thought-provoking '
                    +'articles today.',
                canonical_url: 'https://hola.org/blog/in-depth',
            };
        case 'interviews':
            return {
                title: 'Hola Blog | Exclusive Interviews with Our Thought '
                    +'Leaders',
                description: 'Check out exclusive conversations with our '
                    +'experts to gain insights into the minds of our team & '
                    +'learn valuable lessons on accessing content & staying '
                    +'secure online.',
                canonical_url: 'https://hola.org/blog/interviews',
            };
        case 'news':
            return {
                title: 'Hola | Read Our Latest News and Updates To Stay In '
                    +'The Loop',
                description: 'Stay up-to-date with our latest news now. From '
                    +'Hola news to current affairs and trending topics, get '
                    +'a comprehensive overview of what\'s happening at Hola.',
                canonical_url: 'https://hola.org/blog/news',
            };
        case 'product-news':
            return {
                title: 'Hola Blog | Product News and Updates - Be the First '
                    +'to Know',
                description: 'Be the first to know about new features, '
                    +'improvements, and releases, and stay informed about '
                    +'how our service can benefit you! Check out our product '
                    +'news category.',
                canonical_url: 'https://hola.org/blog/product-news',
            };
        case 'sports':
            return {
                title: 'Watch Live Sports Online from Anywhere with a VPN',
                description: 'Stream live sports from any country. Access'+
                ' geo-blocked sports channels, watch NFL, NBA,'+
                ' Premier League and more with the best VPN'+
                ' for sports streaming.',
                canonical_url: 'https://hola.org/blog/sports',
            };
        case 'shopping':
            return {
                title: 'Online Shopping with VPN: Find Better Prices & Deals'+
                ' Worldwide',
                description: 'Unlock regional prices and find better deals'+
                ' online with a VPN. Learn how geo-blocking'+
                ' affects prices and save money shopping from'+
                ' different virtual locations.',
                canonical_url: 'https://hola.org/blog/shopping',
            };
        case 'social-media':
            return {
                title: 'Access Blocked Social Media Anywhere: VPN'+
                ' Privacy Guide',
                description: 'Can`t access Facebook, Instagram or TikTok?'+
                ' Learn how to unblock social media platforms'+
                ' with a VPN and protect your online privacy on'+
                ' any network or location.',
                canonical_url: 'https://hola.org/blog/social-media',
            };
        case 'travel':
            return {
                title: 'Best VPN for Travel 2025: Stay Secure on'+
                ' Any Network Abroad',
                description: 'Traveling internationally? Discover the best'+
                ' VPN for travel to protect your data on public'+
                ' WiFi, access content from home, and stay safe'+
                ' on any network abroad.',
                canonical_url: 'https://hola.org/blog/travel',
            };
        case 'streaming':
            return {
                title: 'Best VPN for Streaming in 2025: Watch Any'+
                ' Content, Anywhere',
                description: 'Looking for the best VPN for streaming? Learn'+
                ' how to unblock Netflix, Hulu, BBC iPlayer and more with a'+
                ' fast, reliable streaming VPN. Access international '+
                'content easily.',
                canonical_url: 'https://hola.org/blog/streaming',
            };
        default:
            return {
                title: 'Hola | The Latest News On Accessing Content Online',
                description: 'Gain valuable insights into how to unblock '
                    +'websites, protect your privacy, & surf the web with '
                    +'freedom by checking out our blog! Join the Hola '
                    +'community today!',
                canonical_url: 'https://hola.org/blog',
            };
        }
    },
    is_dark_available: true,
    set_data_cache: (data_cache, params, data)=>{
        const cache_key = `/blog/page/${params.page}/category/`+
            `${params.category}/per_page/${params.per_page||9}`;
        data_cache[cache_key] = data;
    },
    get_data_id,
    data_provider: (data_cache, params)=>etask(function*(){
        const cache_key = `/blog/page/${params.page}/category/`+
            `${params.category}/per_page/${params.per_page||9}`;
        const cached = data_cache[cache_key];
        if (cached)
            return cached;
        let not_in = [];
        const end = `https://hola.org/cms_api/blog/posts`;
        not_in = [];
        let data = yield fetch(`${end}?posts_per_page=${params.per_page||9}`+
            `&paged=${params.page||0}${params.category ?
            `&category=${params.category}` : ''}`+
            `${not_in.length>0 ? `&post__not_in=${not_in.join(',')}` : ''}`);
        if (typeof data!='object')
            data = {};
        data.posts = data.posts||[];
        data.categories = data.categories||[];
        const result = {
            data,
            error: '',
            cache_key,
            category: params.category,
        };
        data_cache[cache_key] = result;
        return result;
    }),
};
